module.exports = __webpack_public_path__ + "23a0947ea848bee0e61f8cc3425df362.pdf";